import { createContext } from 'react'

export const VenuesContext = createContext([])